import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-formas-de-pago',
    templateUrl: './formas-de-pago.component.html'
})
export class FormasDePagoComponent {
    @Input() codigoDeBarrasOxxoImagen: any;
    @Input() codigoDeBarrasOxxo: any;
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/components/formas-de-pago/formas-de-pago.component.ts